// src/pages/ProcessamentoDetail.jsx
import React, { useEffect, useState } from 'react'
import api from '../services/api'
import { useParams, useNavigate } from 'react-router-dom'
import Loading from '../components/Loading'
import ErrorToast from '../components/ErrorToast'
import './ProcessamentoDetail.css'

import { FaArrowLeft } from 'react-icons/fa';

const ProcessamentoDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [processo, setProcesso] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchDetail = async () => {
      setLoading(true)
      setError('')
      try {
        const { data } = await api.get(
          `/processamentos/${id}`,
        )
        setProcesso(data)
      } catch {
        setError('Erro ao carregar detalhes do processamento.')
      } finally {
        setLoading(false)
      }
    }
    fetchDetail()
  }, [id])

  if (loading) return <Loading />
  if (error) return <ErrorToast message={error} onClose={() => setError('')} />
  if (!processo) return null

  return (
    <div className="processamento-detail-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        <FaArrowLeft /> Voltar
      </button>
      <h1>Processamento #{processo.id}</h1>
      <div className="detail-row">
        <strong>Tipo:</strong> {processo.tipo_processamento}
      </div>
      <div className="detail-row">
        <strong>Status:</strong> {processo.status}
      </div>
      <div className="detail-row">
        <strong>Usuário:</strong> {processo.usuario_cadastro}
      </div>
      <div className="detail-row">
        <strong>Iniciado em:</strong>{' '}
        {new Date(processo.created_at).toLocaleString()}
      </div>
      <div className="detail-row">
        <strong>Finalizado em:</strong>{' '}
        {processo.data_fim
          ? new Date(processo.data_fim).toLocaleString()
          : '-'}
      </div>
      {/* Se quiser mostrar a lista de imóveis processados, pode renderizar aqui */}
    </div>
  )
}

export default ProcessamentoDetail
